export default {
  methods: {
    // 获取用户id
    getSupplierId () {
      let accoutDto = localStorage.getItem('ACCOUNT_DTO')
      accoutDto = JSON.parse(accoutDto)
      return accoutDto.supplierId || ''
    },
    // 获取角色名
    getRoleName () {
      let accoutDtoStr = localStorage.getItem('ACCOUNT_DTO')
      if (accoutDtoStr) {
        let accoutDto = JSON.parse(accoutDtoStr)
        if (accoutDto.roleNameList && accoutDto.roleNameList.length) {
          return accoutDto.roleNameList
        }
      }
      return []
    }
  }
}
